import type { CountryKey } from "~/types";

const SUCCESS_VISIT_KEY_PREFIX = 'successVisit_';
const RESUME_TOKEN_KEY_PREFIX = 'resumeToken_';

export function cacheResumeToken(country: CountryKey, token: string) {
  const key = getCachedResumeTokenKey(country);
  cache(key, token);
}
export function getCachedResumeToken(country: CountryKey) {
  const key = getCachedResumeTokenKey(country);
  return getCached(key);
}
export function clearCachedResumeToken(country: CountryKey) {
  const key = getCachedResumeTokenKey(country);
  clear(key);
}
function getCachedResumeTokenKey(country: CountryKey) {
  return RESUME_TOKEN_KEY_PREFIX + country;
}

export function cacheSuccessVisit(formId: string) {
  const cacheKey = getCachedSuccessVisitKey(formId);
  flag(cacheKey);
}
export function getCachedSuccessVisit(key: string) {
  return getFlag(getCachedSuccessVisitKey(key));
}
function getCachedSuccessVisitKey(id: string) {
  return SUCCESS_VISIT_KEY_PREFIX + id;
}

export function isCacheAvailable() {
  return Boolean(getStorage());
}

function flag(key: string) {
  cache(key, '1');
}
function getFlag(key: string) {
  return Boolean(getCached(key));
}

function cache<T extends string>(key: string, value: T) {
  getStorage()?.setItem(key, value);
}
function getCached(key: string) {
  return getStorage()?.getItem(key);
}
function clear(key: string) {
  getStorage()?.removeItem(key);
}
function getStorage() {
  if (!window.localStorage) {
    console.error('Local storage is not available in this environment.');
    return;
  }
  return window.localStorage;
}